import { tokenAl } from './authApi';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

function yetkiliBaslik() {
  return {
    Authorization: 'Bearer ' + tokenAl(),
    'Content-Type': 'application/json'
  };
}

export async function islemleriGetir() {
  const response = await fetch(`${API_BASE}/api/islemler`, { headers: yetkiliBaslik() });
  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'İşlemler alınamadı');
  }

  return veri.islemler;
}

export async function islemEkle(hisseKodu, islemTipi, adet, fiyat) {
  const response = await fetch(`${API_BASE}/api/islemler`, {
    method: 'POST',
    headers: yetkiliBaslik(),
    body: JSON.stringify({ hisse_kodu: hisseKodu, islem_tipi: islemTipi, adet, fiyat })
  });

  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'İşlem eklenemedi');
  }

  return veri;
}

export async function pozisyonlariGetir() {
  const response = await fetch(`${API_BASE}/api/pozisyonlar`, { headers: yetkiliBaslik() });
  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'Pozisyonlar alınamadı');
  }

  return veri.pozisyonlar;
}
